import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { PhoneNotifications } from '../PhoneNotifications'

import * as S from './styles'

export const NotificationsCardWrapper: React.FC = () => {  
  return (
    <S.Container>
      <S.WrapperTitle>
        <Typography weight='bold' variant="content1">Lembretes da consulta</Typography>
        <Typography customClassName='subtitle' variant="content3">Escolha como quer receber seus lembretes</Typography>
      </S.WrapperTitle>

      <PhoneNotifications />
    </S.Container>
  )
}